import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext.js';

// Компонент для публичных роутов (только для неавторизованных)
const PublicRoute = ({ 
  children, 
  redirectTo = '/dashboard',
  fallback = null 
}) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Показываем загрузку пока проверяем авторизацию
  if (loading) {
    return fallback || (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#0a0a0a'
      }}>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} 
          size="large"
        />
      </div>
    );
  }

  // Если авторизован, редиректим на главную страницу
  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Не авторизован, показываем публичный контент
  return children;
};

export default PublicRoute;
